export enum UniversalMappingField {
  FILEPATH = 'Filepath',
  REVISION = 'Revision',
  DOCUMENT_ID = 'documentId',
  KKS = 'KKS',
}
